module.exports = __webpack_public_path__ + "static/img/1ortho3.d470e28a.png";